import React, { useState, useEffect } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';

import './PageMain.scss';
import './PageMain-media.scss';
import SliderLogos from '../../components/SliderLogos/SliderLogos';
import DeliveryTypes from '../../components/DeliveryTypes/DeliveryTypes';
import Content from '../../components/Content/Content';
import BlockWeAreTrusted from '../../components/BlockWeAreTrusted/BlockWeAreTrusted';
import FormContacts from '../../components/FormContacts/FormContacts';
import { MediaContent } from '../../services/GlobalFunctions';
import { AnchorSection } from 'react-anchor-navigation';
import SliderReviews from '../../components/SliderReviews/SliderReviews';
import MainBlock from '../../components/MainBlock/MainBlock';
import StoriesBlock from '../../components/Stories/StoriesBlock/StoriesBlock';
import { Props } from './interfaces';
import SMI from '../../components/SMI/SMI';
import BlockCarousel from '../../components/BlockCarousel/BlockCarousel';
import FormContactsNew from '../../components/FormContactsNew/FormContactsNew';
import { SMIList } from '../../components/SMI/Constants';
import PageTracking from '../PageTracking/PageTracking';
import { useLocation } from 'react-router-dom';
import Advantages from '../../components/Advantages/Advantages';
import {content} from "../../services/content";
import {IWordpressBlockMain} from "../../services/content/interfaces/blocks/IWordpressBlockMain";
import {getPageName, isEmpty, loadPageContent} from "../../services/content/functions";
import {APIWordpress} from "../../redux/services/APIRequestsWordpress";
import {IWordpressBlockCounters} from "../../services/content/interfaces/blocks/IWordpressBlockCounters";
import {Faq} from "../../components/Faq/Faq";
import {IWordpressBlockFaq} from "../../services/content/interfaces/blocks/IWordpressBlockFaq";
import {IWordpressDeliveryTypes} from "../../services/content/interfaces/IWordpressDeliveryTypes";
import {IWordpressBlockBlue} from "../../services/content/interfaces/blocks/IWordpressBlockBlue";
import DescriptionBlock from "../../components/DescriptionBlock/DescriptionBlock";

interface PageContent {
  main?: IWordpressBlockMain;
  counters?: IWordpressBlockCounters;
  faq?: IWordpressBlockFaq;
  delivery_types?: IWordpressDeliveryTypes;
  blue_block?: IWordpressBlockBlue;
}

const PageMain = ({
  stories,
  advantagesSlider,
  advantagesSliderTitle,
  reviews,
  widthWindow,
  logosPartners,
  alertLoaded
}: Props) => {
  const [widthContent, setWidthContent] = useState('1280px');
  useEffect(() => {
    setWidthContent(widthWindow > 1439 ? '1440px' : '100vw');
  }, [widthWindow]);

  const location = useLocation();
  const UpdateUrl = () => {
    return {
      number: urlParams.get('number'),
      phone: urlParams.get('phone'),
    };
  };

  const [urlParams, setUrlParams] = useState(new URLSearchParams(location.search));
  const [searchUrls, setSearchUrl] = useState(UpdateUrl());
  const [pageContent, setPageContent] = useState<PageContent>({})
  useEffect(() => {
    const name = 'main';
    let content = loadPageContent(name);
    if (isEmpty(content)) {
      APIWordpress.getContentByPage(name).then((data) => {
        setPageContent(data);
      }).catch((err) => alertLoaded(err));
    } else {
      setPageContent(content);
    }
  }, []);

  useEffect(() => {
    setUrlParams(new URLSearchParams(location.search));
    setSearchUrl(UpdateUrl());

    if (location.search === '') {
      setSearchUrl({number: null, phone: null});
    }
  }, [location.search]);

  if (searchUrls.number && searchUrls.phone) {
    return <PageTracking pageName="Отслеживание (по ссылке)"/>;
  }

  return (
    <div className="page-main">

      {pageContent.main && <Content
        noLazy
        block={<MainBlock mainData={pageContent.main}/>}
        padding={{paddingMain: {top: 0, bottom: 60}, paddingMob: {top: 0, bottom: 40}}}
      />}

      {stories.length
        ? MediaContent(
          <Content
            block={
              <StoriesBlock
                stories={stories}
                padding={widthWindow > 720 ? {top: 60, bottom: 60} : {top: 40, bottom: 40}}
              />
            }
          />,
          <StoriesBlock stories={stories}/>
        )
        : null}

      {pageContent.counters &&
      <AnchorSection id="confidence">
          <Content
              block={<BlockWeAreTrusted {...pageContent.counters}/>}
              padding={{paddingMain: {top: 60, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          />
      </AnchorSection>}
      {logosPartners.length ? <Content block={<SliderLogos/>}/> : null}

      {pageContent.delivery_types?.visible && <AnchorSection id="delivery">
        <Content
          block={<DeliveryTypes title={pageContent.delivery_types.title} list={pageContent.delivery_types.items}/>}
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        />
      </AnchorSection>}

      {pageContent.main?.advantages?.items?.length ? (
        <Content
          block={
            <Advantages
              title={pageContent.main.advantages.title}
              text={pageContent.main.advantages.subtitle}
              list={pageContent.main.advantages.items}
            />
          }
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        />
      ) : null}

      <Content
        width={widthContent}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={<BlockCarousel title={advantagesSliderTitle} list={advantagesSlider}/>}
      />

      <AnchorSection id="form-send-main">
        <Content
          block={<FormContacts eventMetrika="form_club" sendAmoCRM/>}
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        />
      </AnchorSection>

      <Content
        block={<SliderReviews title={content.sliderContent.reviews.title} slides={reviews}/>}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
      />

      <Content
        block={<SMI list={SMIList}/>}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
      />

      {pageContent.blue_block?.visible && <Content
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <DescriptionBlock
              open
              title={pageContent.blue_block.title}
              text={pageContent.blue_block.content}
            />
          }
      />}

      <Content
        block={<FormContactsNew telegram eventMetrika="form_questions" sendAmoCRM/>}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
      />

      {pageContent.faq?.visible && pageContent.faq.items && <Content
        padding={{paddingMain: {top: 80, bottom: 0}, paddingMob: {top: 40, bottom: 0}}}
        block={
          <div className="page-main__questions">
            <Faq className={'page-main__questions'} title={pageContent.faq.title} items={pageContent.faq.items} expanded={pageContent.faq.expanded}/>
          </div>
        }
      />}
    </div>
  );
}

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageMain));
